import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { collectionToStories } from "@quintype/components";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import { DfpComponent } from "../../ads/dfp-component";
import StoryCard from "./StoryCard";

import "./portrait-six-stories.m.css";

export default function PortraitSixStories({ collection, extraProp = "" }) {
  const associatedMetadata = get(collection, ["associated-metadata"], {});
  const showRowTitle = associatedMetadata.show_row_title || null;
  const showColumnSeparator = associatedMetadata.show_column_separator || null;
  const showRowSeparator = associatedMetadata.show_row_separator || null;
  const rowAdUnitBottom = associatedMetadata.row_ad_unit_string || null;
  const enableSponsorAd = associatedMetadata.enable_sponsor_ad || null;
  const sponsorAdDetails = associatedMetadata.sponsor_ad_details || null;
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));

  const rowAdBottom = rowAdUnitBottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));

  const stories = collectionToStories(collection);
  const sectionSlug = extraProp;

  if (!stories.length) return null;

  return (
    <div className="row-component" styleName="top-component-wrapper">
      <div styleName="portrait-six-stories">
        {showRowTitle && (
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enableSponsorAd}
            sponsorAdDetails={sponsorAdDetails}
            sectionSlug={sectionSlug}
            sponsorAdConfig={sponsorAdConfig}
            containerStyles={"portrait-six-stories"}
          />
        )}
        <div styleName={`${showColumnSeparator ? "portrait-list-with-seperator" : "portrait-list"}`}>
          {stories.map((story, index) => {
            return (
              <Fragment key={index}>
                <StoryCard story={story} sectionSlug={sectionSlug} />
                {showColumnSeparator && index !== stories.length - 1 && <div styleName="divider"></div>}
              </Fragment>
            );
          })}
        </div>
      </div>
      {showRowSeparator && <RowSeparator />}
      {rowAdUnitBottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
}

PortraitSixStories.propTypes = {
  collection: PropTypes.object.isRequired,
  stories: PropTypes.array.isRequired,
  extraProp: PropTypes.string,
};

PortraitSixStories.storyLimit = 6;
